module.exports = __webpack_public_path__ + "img/wa-bg-light.bfe85d5f.jpg";